import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';
import { distributorService } from '../services/DistributorService';

export const DistributorSettingsContext = createContext();

export const DistributorSettingsProvider = props => {
    const [stripeKey, setStripeKey] = useState();

    const updateStripeKey = useCallback(stripeKey => {
        setStripeKey(stripeKey);
        return distributorService.putSettings(stripeKey);
    }, []);

    const checkStripeConnectAccount = useCallback(async (id) => {
        return await distributorService.checkStripeConnectAccount(id);
    }, []);

    const manageStripeConnectAccount = useCallback(async (id) => {
        return await distributorService.manageStripeConnectAccount(id);
    }, []);

    const values = useMemo(() => ({
        stripeKey,
        updateStripeKey,
        checkStripeConnectAccount,
        manageStripeConnectAccount
    }), [
        stripeKey,
        updateStripeKey,
        checkStripeConnectAccount,
        manageStripeConnectAccount
    ]);

    return (
        <DistributorSettingsContext.Provider value={values}>
            {props.children}
        </DistributorSettingsContext.Provider>
    );
};

export const useDistributorSettings = () => {
    const context = useContext(DistributorSettingsContext);

    if (context === undefined) {
        throw new Error(
            'useDistributorSettings must be used within a DistributorSettingsProvider component.'
        );
    }

    return context;
};
